import { render, staticRenderFns } from "./IntelligentStorage.vue?vue&type=template&id=76236012&scoped=true&"
import script from "./IntelligentStorage.vue?vue&type=script&lang=js&"
export * from "./IntelligentStorage.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentStorage.vue?vue&type=style&index=0&id=76236012&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76236012",
  null
  
)

export default component.exports